export interface YuzuncuMaddeyeYararBilgiIstenilmesiParamsInterface {
    // UYAP'ta 0 ("Taşınır") geçerli bir mal türü oldugu icin "secilmedi" durumu null'dur.
    malTip: number | null,
    malTipAciklama: string,
    aciklama: string,
}

export interface BankadanHacizliParaninIstenilmesiParamsInterface {
    bankaList: number[],// Bankalarin IDLERININ tutuldugu number array i
    hacizTarihi: string,
    aciklama: string
}

export interface BorcluTarafindanYapilanOdemelerinHesabaAktarilmasiParamsInterface {
    ibanNo: string,
    hesapKimeAit: "Vekil" | "Avukat"
}

export interface DosyadaHacizliMalinSatisiParamsInterface {
    // UYAP'ta 0 ("Taşınır") geçerli bir mal türü oldugu icin "secilmedi" durumu null'dur.
    malTip: number | null,
    malTipAciklama: string,
    aciklama: string,
    hacizTarihi: string
}

export type DosyadakiAvansinIadesiParamsInterface = BorcluTarafindanYapilanOdemelerinHesabaAktarilmasiParamsInterface

export type KiymetTakdirininYapilmasiParamsInterface = DosyadaHacizliMalinSatisiParamsInterface

export interface DosyaninIslemdenKaldirilmasiParamsInterface {
    aciklama: string,
    kapanmaAdi: string,
    // UYAP'ta 0 ("İnfaz") geçerli bir kapanma nedeni oldugu icin "secilmedi" durumu null ile ifade edilir.
    kapanmaId: number | null
}

export interface DosyaninYetkiliIcraDairesineGonderilmesiParamsInterface {
    aciklama: string,
    birimAdi: string,
    birimId: number
}

export interface DosyaYenilemeTalebiParamsInterface {
    aciklama: string
}

export interface HacizliMalinKiymetTakdiriIcinTalimatYazilmasiParamsInterface {
    aciklama: string,
    birimAdi: string,
    birimId: number,
    hacizTarihi: string,
    // UYAP'ta 0 ("Taşınır") geçerli bir mal türü oldugu icin "secilmedi" durumu null'dur.
    malTip: number | null,
    malTipAciklama: string,
}

export type HacizliMalinSatisiIcinTalimatYazilmasiParamsInterface = HacizliMalinKiymetTakdiriIcinTalimatYazilmasiParamsInterface;

export interface HaricenTahsilatBildirimiParamsInterface {
    tahsilatTarihi: string,
    tahsilatTutari: number,
    aciklama: string
}

export interface MaasUzerindekiHacizlerinKaldirilmasiParamsInterface {
    aciklama: string,
    // UYAP'ta 0 ("Çalışan Kamu") geçerli bir çalışma durumu oldugu icin
    // "secilmedi" durumu null ile ifade edilir.
    calismaDurumu: number | null
}

export interface MuhafazaAltindakiMallarinHacizBakiKalarakYeddieminDegisikligiParamsInterface {
    aciklama: string,
    muhafazaTarihi: string,
    yeddiemin: string
}

export interface RehinAcigiBelgesiHazirlanmasiParamsInterface {
    // Radyo degerleri string oldugu icin sayisal 0 "secilmedi" anlamina gelir; null kullanilir.
    belgeTip: number | null,
    belgeTipAciklama: string,
    aciklama: string
}

export interface TasinmazHacizKaldirilmasiParamsInterface {
    hacizTarihi: string,
    aciklama: string
}

export class DigerTalepParamsInterface {
    yuzuncuMaddeyeYararBilgiIstenilmesiParams: YuzuncuMaddeyeYararBilgiIstenilmesiParamsInterface = {
        malTip: null,
        malTipAciklama: "",
        aciklama: "",
    }

    acizBelgesiHazirlanmasiParams: {
        aciklama: string
    } = {
        aciklama: ""
    }

    aracUzerindekiHacizSerhininKaldirilmasiParams: {
        plaka: string
    } = {
        plaka: ""
    }

    aracUzerindekiYakalamaSerhininKaldirilmasiParams: {
        plaka: string
    } = {
        plaka: ""
    }

    bankadanHacizliParaninIstenilmesiParams: BankadanHacizliParaninIstenilmesiParamsInterface = {
        bankaList: [],// Bankalarin IDLERININ tutuldugu number array i
        hacizTarihi: "",
        aciklama: ""
    }

    borclutarafindanYapilanOdemelerinHesabaAktarilmasiParams: BorcluTarafindanYapilanOdemelerinHesabaAktarilmasiParamsInterface = {
        ibanNo: "",
        hesapKimeAit: "Avukat"
    }

    dosyadaHacizliMalinSatisiParams: DosyadaHacizliMalinSatisiParamsInterface = {
        malTip: null,
        malTipAciklama: "",
        aciklama: "",
        hacizTarihi: ""
    }

    dosyadakiAvansinIadesiParams: DosyadakiAvansinIadesiParamsInterface = {
        ibanNo: "",
        hesapKimeAit: "Avukat"
    }

    dosyadakiHacizlerinKaldirilmasiParams: {
        aciklama: string
    } = {
        aciklama: ""
    }

    dosyaninIslemdenKaldirilmasiParams: DosyaninIslemdenKaldirilmasiParamsInterface = {
        aciklama: "",
        kapanmaAdi: "",
        kapanmaId: null
    }

    dosyaninYetkiliIcraDairesineGonderilmesiParams: DosyaninYetkiliIcraDairesineGonderilmesiParamsInterface = {
        aciklama: "",
        birimAdi: "",
        birimId: 0
    }

    dosyaYenilemeTalebiParams: DosyaYenilemeTalebiParamsInterface = {
        aciklama: ""
    }

    hacizliMalinKiymetTakdiriIcinTalimatYazilmasiParams: HacizliMalinKiymetTakdiriIcinTalimatYazilmasiParamsInterface = {
        aciklama: "",
        birimAdi: "",
        birimId: 0,
        hacizTarihi: "",
        malTip: null,
        malTipAciklama: "",
    }

    hacizliMalinSatisiIcinTalimatYazilmasiParams: HacizliMalinSatisiIcinTalimatYazilmasiParamsInterface = {
        aciklama: "",
        birimAdi: "",
        birimId: 0,
        hacizTarihi: "",
        malTip: null,
        malTipAciklama: "",
    }

    hacizliTasinirMallarinMuhafazaAltinaAlinmasiParams: { hacizTarihi: string } = {
        hacizTarihi: ""
    }

    haricenTahsilatBildirimiParams: HaricenTahsilatBildirimiParamsInterface = {
        tahsilatTarihi: "",
        tahsilatTutari: 0,
        aciklama: ""
    }

    iik121MaddeyeGoreYetkiVerilmesiParams: { aciklama: string } = {
        aciklama: ""
    }

    iik150cSerhiEklenmesiParams: { aciklama: string } = {
        aciklama: ""
    }

    kiymetTakdirininYapilmasiParams: KiymetTakdirininYapilmasiParamsInterface = {
        malTip: null,
        malTipAciklama: "",
        aciklama: "",
        hacizTarihi: ""
    }

    maasUzerindekiHacizlerinKaldirilmesiParams: MaasUzerindekiHacizlerinKaldirilmasiParamsInterface = {
        aciklama: "",
        calismaDurumu: null
    }

    muhafazaAltindakiMallarinHacizBakiKalarakYeddieminDegisikligiParams: MuhafazaAltindakiMallarinHacizBakiKalarakYeddieminDegisikligiParamsInterface = {
        aciklama: "",
        muhafazaTarihi: "",
        yeddiemin: ""
    }

    rehinAcigiBelgesiHazirlanmasiParams: RehinAcigiBelgesiHazirlanmasiParamsInterface = {
        belgeTip: null,
        belgeTipAciklama: "",
        aciklama: ""
    }

    rehininParayaCevrilmesiSerhiParams: { aciklama: string } = {
        aciklama: ""
    }

    tasinmazHaczininKaldirilmasiParams: TasinmazHacizKaldirilmasiParamsInterface = {
        hacizTarihi: "",
        aciklama: ""
    }

    ibanGuncellemeParams: {
        ibanSecimi: string,
        ibanNo: string
    } = {
        ibanNo: "",
        ibanSecimi: ""
    }
}